import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { OfferSelectionCardModel, TextModel } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-unified-plans-layout',
  templateUrl: './unified-plans-layout.component.html',
  styleUrls: ['./unified-plans-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnifiedPlansLayoutComponent {
  @Input() offers: OfferSelectionCardModel[] | null
  @Input() selectedOffer: OfferSelectionCardModel | null
  @Input() valueProps: ReadonlyArray<Pick<TextModel, 'text' | 'style'>> | null

  @Output() offerSelected = new EventEmitter<OfferSelectionCardModel>()

  readonly trackById = trackById

  onOfferClick(offer: OfferSelectionCardModel): void {
    this.offerSelected.emit(offer)
  }
}
